export const OFFERS_TO_SHOW = 20;
export const CASHBACK_BOTTOMSHEET = 'cashback-bottom-sheet';
